import { render } from "./VisitorInfoForm.vue?vue&type=template&id=bca84988&scoped=true"
import script from "./VisitorInfoForm.vue?vue&type=script&lang=js"
export * from "./VisitorInfoForm.vue?vue&type=script&lang=js"

import "./VisitorInfoForm.vue?vue&type=style&index=0&id=bca84988&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bca84988"]])

export default __exports__